// Interface

import util from '@/utils/classToObject'
import { IUiState } from './state'

export class UiGetter {
     
    public contentHeight(state: IUiState){
        return state.contentHeight
    }

    public rightDrawerOpen(state: IUiState){
        return state.rightDrawerOpen
    }

    public rightDrawerEnable(state: IUiState){
        return state.rightDrawerEnable
    }   
    
    public snackMessages(state: IUiState) {
        return state.snackMessages
    }    

    public showAllergene(state: IUiState) {
        return state.showAllergene && !state.printMode
    }      

    public showCart(state: IUiState) {
        return state.showCart
    }      

    public searchSejour(state: IUiState) {
        return state.searchSejour
    } 

    public sortSejourDesc(state: IUiState) {
        return state.sortSejourDesc
    }   

    public sortSejourBy(state: IUiState) {
        return state.sortSejourBy
    }  


    public searchUser(state: IUiState) {
        return state.searchUser
    } 

    public sortUserDesc(state: IUiState) {
        return state.sortUserDesc
    }   

    public sortUserBy(state: IUiState) {
        return state.sortUserBy
    } 


    public searchCommande(state: IUiState) {
        return state.searchCommande
    } 

    public sortCommandeDesc(state: IUiState) {
        return state.sortCommandeDesc
    }   

    public sortCommandeBy(state: IUiState) {
        return state.sortCommandeBy
    } 

    public searchMailTemplate(state: IUiState) {
        return state.searchMailTemplate
    } 

    public sortMailTemplateDesc(state: IUiState) {
        return state.sortMailTemplateDesc
    }   

    public sortMailTemplateBy(state: IUiState) {
        return state.sortMailTemplateBy
    } 

    public searchMailSkin(state: IUiState) {
        return state.searchMailSkin
    } 

    public sortMailSkinDesc(state: IUiState) {
        return state.sortMailSkinDesc
    }   

    public sortMailSkinBy(state: IUiState) {
        return state.sortMailSkinBy
    }  

    public printMode(state: IUiState) {
        return state.printMode
    }  
    
    
        
}

export default util.classToObject(UiGetter)